import ShareLevel from '../constants/Day6ShareLevel'

const feedbackSurveyUrl = 'https://forms.gle/NVVEHPxRVNBE9pHv8'

const shareLevelHintMap = {
  [ShareLevel.NONE]: 'Not sharing',
  [ShareLevel.PUBLIC]: 'Character is shared',
  [ShareLevel.VERSIONS]: 'Some versions are shared',
  [ShareLevel.PRIVATE]: 'Character is not shared'
}

export default {
  appTitle: 'qharacter',
  qharacter: 'qharacter',
  abort: 'Abort',
  accountSharingNotReady: 'Sharing of characters under an account is currently in development and not ready for release. This link will work for you but not for others.',
  animationGenerationInProgress: 'Finish or cancel animation generation before continuing.',
  assetBuildEstimate: (minMinutes = 2, maxMinutes = 5) => `This character will be ready in ${minMinutes}-${maxMinutes} minutes. It could be longer depending on the number of current users.`,
  assetDownloaPaidFeature: 'Downloading characters is a paid feature. Start a free trial or subscription to begin downloading.',
  askLoadLatest: 'A newer version of this character exists. Would you like to load it?',
  browserCharacters: 'Browse characters',
  buildTimeEstimate: 'Build time estimate',
  characterBrowserPaidFeature: 'Accessing characters is a paid feature. Start a free trial or subscription to see previously created characters.',
  characterChangeDownloadAgain: 'The character was changed during asset generation. Press download again to generate the asset with newer changes.',
  characterPreviewNotSupported: 'Sorry. Previewing is not supported at the moment.',
  checkConnectionRefresh: 'We are unable to connect to our servers. Either our servers are down or the current connection to the internet is unreliable. Refresh to try again.',
  confirmAbortPoseEstimate: 'Would you like to abandon pose detection?',
  confirmAbortGenerateAnimation: 'Would you like to abandon animation generation?',
  copiedToClipboard: 'Copied share link',
  day6Updates: 'Character Updates',
  deletePoseSequenceFailTryAgain: 'Unable to delete pose/animation. Try again later.',
  detectPose: 'Detect pose',
  downloadHint: 'Save asset file',
  feedbackSurveyUrl,
  getLinkCopyMessage: link => `Copied link to clipboard.\nAnyone accessing the link is able to make and save changes to this character.\n${link}`,
  hideFutureMessage: 'Hide this message in the future',
  invalidCharacterLink: 'This character does not exist. Feel free to create a new one.',
  issuePreviewingAnimation: 'There was an issue loading this pose/animation. We will be looking into this. In the meantime feel free to share this with us to get it resolved faster.',
  loadPoseSequenceFailTryAgain: 'Unable to load pose/animation. Try again later.',
  loadingDotDotDot: 'Loading...',
  mailingList: 'Mailing list',
  modelingCharacterHint: 'Model character',
  noSavingSmallScreenAnimations: 'Editing animations on smaller devices is difficult. Changes will not be saved to avoid overwriting inadvertently.',
  pendingGenerateLocomotion: 'Generated animation is not applied. Would you like to Abort and lose unsaved changes?',
  pendingPoseEstimateApply: 'A pose is not applied fully. Would you like to Abort and lose unsaved changes?',
  poseAnimateCharacterHint: 'Pose/animate character',
  poseCharacterHint: 'Pose character',
  poseLibrary: 'Pose library',
  poseMarketingVideos: ({
    jumpinJoy: {
      shareId: 'bzg6fVBfJXbJQMRAj0J8',
      fileName: 'jj-crop'
    },
    elegantTwirl: {
      shareId: 'iiALQvYwmEuyK2N715X4',
      fileName: 'et-crop'
    },
    precariousCatch: {
      shareId: '8W4pjNF8DDjz2C1zGXpg',
      fileName: 'pc-crop',
      fullWidth: true
    },
    thrillingRun: {
      shareId: 'alum9DtKlwh5ZU06eMRW',
      fileName: 'tr-crop'
    },
    slippinFall: {
      shareId: 'nmjHTgiAaGv6YXtCy9Dq',
      fileName: 'sf-crop'
    },
    creepyCrawl: {
      shareId: 'cjO37InB95tIKf7pAjOo',
      fileName: 'cc-crop',
      fullWidth: true
    }
  }),
  previewGenerated: 'Preview character',
  promptSaveChanges: 'Changes have been made. Would you like to save changes?',
  reload: 'Reload',
  reset: 'Reset',
  save: 'Save',
  savingChanges: 'Saving changes...',
  shareLinkHint: 'Copy share link',
  signInToSeeCharacters: 'Sign in to see data',
  start: 'Start',
  takeFeedbackSurvey: `We are interested in how and why you create characters. Would you mind sharing your <a class="accent--text" href="${feedbackSurveyUrl}" target="_blank">experience</a> with us?`,
  unityLoadErrorDescription: 'This browser may not support our underlying technologies. If possible try on a different browser. If not reach out to support for troubleshooting assistance.',
  shareLevelHint: shareLevel => {
    return shareLevel in shareLevelHintMap
      ? shareLevelHintMap[shareLevel]
      : 'Checking if character is shared...'
  }
}
